<template>
    <div>
        <vx-card title="¿Cómo te califican tus clientes?">
            <div id="service">
                <statistics-feedback
                    title="Servicio / Atención a Cliente."
                    :score="values.serviceAvg != null ? values.serviceAvg: 0"
                    :value="5"
                    :percent="getPercentage(values.serviceAvg != null ? values.serviceAvg: 0)"
                    color="#f39200" />
            </div>
            <div id="credit">
                <statistics-feedback
                    title="Instalación/Entrega del Proyecto."
                    :score="values.projectAvg != null ? values.projectAvg: 0"
                    :value="5"
                    :percent="getPercentage(values.projectAvg != null ? values.projectAvg: 0)"
                    color="#f39200" />
            </div>
            <div id="rg">
                <statistics-feedback
                    title="¿Recomendarías al Proveedor?"
                    :score="values.single != null ? values.single: 0"
                    :value="5"
                    :percent="getPercentage(values.single != null ? values.single: 0)"
                    color="#f39200" />
            </div>
            <div id="average">
                <statistics-feedback
                    title="Promedio."
                    :score="values.average != null ? values.average : 0"
                    :value="5"
                    :percent="getPercentage(values.average != null ? values.average : 0)"
                    color="#2d2d2d" />
            </div> 
            <div class="mt-6">
                <vs-button :disabled="comments == 0" @click="popupActivo = true" color="warning" type="border" icon-pack="feather" icon="icon-eye">Ver comentarios</vs-button>
            </div>       
        </vx-card>

        <!-- MODAL COMENTARIOS -->
        <vs-popup title="Comentarios" :active.sync="popupActivo">
            <vs-list :key="index" v-for="(comment, index) in comments">
                <vs-list-header :title="`PID ${comment.pid} - ${comment.alias}`" color="warning"></vs-list-header>
                <vs-list-item :title="`CID ${comment.cid} - ${comment.name}`" :subtitle="comment.answer">
                    <vs-chip color="dark">{{dateTimeFormat(comment.date)}}</vs-chip>
                    <template slot="avatar">
                    <vs-avatar style="margin-right: 1rem;" vs-text="Vue"/>
                    </template>
                </vs-list-item>
            </vs-list>
        </vs-popup>
        <!--  -->
    </div>
</template>

<script>
const spQuestionIds = [56,57,58,59];
import StatisticsFeedback from '../components/projectsv2/StatisticsFeedback.vue';
import * as moment from "moment";
import dateHelper from "@mixins/dateHelper";
export default {
    mixins: [dateHelper],
    name: "supplier-survey-feedback",
    props: ['SupplierID'],
    components: {
        StatisticsFeedback
    },
    data() {
        return {
            sp_start: "2020-11-01"
            , sp_end: "2020-11-30"
            , spQuestionIds: spQuestionIds
            , hasToShow: 0
            , values: {
                serviceAvg: 0
                , projectAvg: 0
                , single: 0
                , average: 0
            }
            , comments: [
                {
                    question_id: 0,
                    answer: "",
                    date: "",
                    name: "",
                    pid: 0,
                    alias: "",
                    cid: 0
                },
            ],
            popupActivo: false
        }
    },
    created(){
        let end = moment().locale("es").format('YYYY-MM-DD');
        let start = moment().subtract(90, "days").format('YYYY-MM-DD');
        this.rg_start = start;
        this.rg_end = end;
        this.sp_start = start;
        this.sp_end = end;
        this.getRGValues();

    },
    methods: {
        async getRGValues(){
            try{                
                let payload = {
                    qids: this.spQuestionIds
                    , type: 1
                    , id: this.SupplierID
                    , start: this.sp_start 
                    , end: this.sp_end
                };
                
                let response = await axios.post('/api/applicant_satisfaction_survey/getApplicantSurveyResponses', payload);
                this.values = this.calculatevalues(response.data.values);
                this.comments = response.data.comments;
                this.hasToShow = response.data.total;
            } catch(err){
                this.failedOperationNotif("Error al cargar");
            }
        },
        getPercentage(value) {
            return (value * 100) / 5;
        },
        calculatevalues(surveyScores){
            let result = {
                serviceAvg: 0
                , projectAvg: 0
                , single: 0
                , average: surveyScores.average
            };
            let counters = [0,0,0];
            surveyScores.values.forEach(ss => {
                switch(ss.type){
                    case "services":
                        result.serviceAvg += ss.average;
                        counters[0]++;
                        break;
                    case "projects":
                        result.projectAvg += ss.average;
                        counters[1]++;
                        break;
                    case "single":
                        result.single += ss.average;
                        counters[2]++;
                        break;
                    default: console.log("valor no comprendido");
                }
            });

            result.serviceAvg = result.serviceAvg / counters[0];
            result.projectAvg = result.projectAvg / counters[1];
            result.single = result.single / counters[2];

            return result;
        }
    }
}
</script>

<style lang="css" scoped>

</style>